import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {SpinController} from "@nolimitcity/slot-game/bin/core/spin/SpinController";
import {BarbarianFuryGameConfig} from "../BarbarianFuryGameConfig";
import {BarbarianFuryGameModuleConfig} from "../BarbarianFuryGameModuleConfig";
import {BarbarianFuryGameMode} from "../gamemode/BarbarianFuryGameMode";
import {BarbarianFuryParsedGameData} from "../server/data/BarbarianFuryParsedGameData";

/**
 * Created by Pradeep Kumar on 05/20/2019.
 */

export class BarbarianFurySpinController extends SpinController {
    private _activeSymbol:string = "";
    private _prevActiveSymbol:string = "empty";
    private _nextModeReelStrip:string = "";
    private _stickySymbols:boolean[];
    private _noNudgeReel:number[] = [];
    private _data:BarbarianFuryParsedGameData;

    constructor() {
        super();
        EventHandler.addLastEventListener(this, SpinEvent.SKIP, (event:GameEvent) => this.onSkip());
    }

    /**
     * @description This method tells us which reels to spin during respin.
     */
    protected getReelsGameConfigFromPreviousGameData():boolean[] {
        let config:boolean[] = super.getReelsGameConfigFromPreviousGameData();

        if((this._mode === BarbarianFuryGameMode.STACKED_RESPIN) || (this._mode === BarbarianFuryGameMode.STACKED_RESPIN_FREESPIN)) {
            config = this._stickySymbols;
        }
        return config;
    }

    protected parseGameData(data:BarbarianFuryParsedGameData):void {
        this._data = data;
        this._stickySymbols = data.initialStackOverlay ? data.initialStackOverlay.reduce((acc, currEl) => acc.concat(<any>currEl), []) : []; // need to type cast it as this reduce will not work directly on boolean.

        this._nextModeReelStrip = data.nextMode;
        this._activeSymbol = (data as any).activeStackedSymbol;
        let wildOverlay = (data as any).overlayWildInRespin;
        this._noNudgeReel = [];
        // did it to get last spinning reel from initialStackOverlay.
        if(data.nextMode.indexOf("RESPIN") !== -1) {
            let arr:number[] = [0, 1, 2, 3, 4];
            for(let index = 0; index < data.initialStackOverlay.length; index++) {
                //  wildOverlay[index] added this to fix #231
                if(data!.initialStackOverlay[index] || wildOverlay[index]) {
                    arr.splice(arr.indexOf(index), 1);
                }
            }
            this._noNudgeReel = arr;
        }
        if(wildOverlay !== undefined) {
            for(let i:number = 0; i < wildOverlay.length; i++) {
                if(wildOverlay[i] && !(this._stickySymbols[i])) {
                    this._stickySymbols[i] = wildOverlay[i];
                    if(this._data.nextMode === BarbarianFuryGameMode.STACKED_RESPIN || this._data.nextMode === BarbarianFuryGameMode.STACKED_RESPIN_FREESPIN) {
                        EventHandler.dispatchEvent(new GameEvent("setStickyWild", true));
                    }
                }
            }
        }

        this._stickySymbols = this._stickySymbols.map(b => !b);
    }

    protected onAllWinPresentationsCompleted():void {
        super.onAllWinPresentationsCompleted();
        this.removeFrozenWild();
    }

    /*protected isSkippable(): boolean{
        super.isSkippable();
        return false;
    }*/

    protected onSkip():void {
        this.removeFrozenWild();
    }

    private removeFrozenWild():void {
        if(this._data.mode === BarbarianFuryGameMode.STACKED_RESPIN || this._data.mode === BarbarianFuryGameMode.STACKED_RESPIN_FREESPIN) {
            EventHandler.dispatchEvent(new GameEvent("removeFrozenAnimations", this._data.initialStackOverlay));
        }
    }

    // to update fake reels during RESPIN
    // #166
    protected startSpin():void {
        if((this._nextModeReelStrip && this._nextModeReelStrip.indexOf("RESPIN") !== -1)) {
            if(this._activeSymbol !== this._prevActiveSymbol) {
                for(let i:number = 0; i < BarbarianFuryGameConfig.instance.REEL_SETS.STACKED_RESPIN_REELSET.length; i++) {
                    for(let j = 0; j < 4; j++) {
                        (BarbarianFuryGameConfig.instance.REEL_SETS.STACKED_RESPIN_REELSET[i][j]) = "";
                        (BarbarianFuryGameConfig.instance.REEL_SETS.STACKED_RESPIN_REELSET[i][j]) = this._activeSymbol + "*" + j;
                        (BarbarianFuryGameConfig.instance.REEL_SETS.STACKED_RESPIN_FS_REELSET[i][j]) = "";
                        (BarbarianFuryGameConfig.instance.REEL_SETS.STACKED_RESPIN_FS_REELSET[i][j]) = this._activeSymbol + "*" + j;
                    }
                }
                this._prevActiveSymbol = this._activeSymbol;
            }
            BarbarianFuryGameModuleConfig.foregroundAnimation.playRespinAnticipation(this._noNudgeReel);
            SlotGame.sound.playEffect("anticipation");
        }

        super.startSpin();
    }
}
